





















































































































































import {
  defineComponent,
  PropType,
  ref,
  computed,
  onMounted,
  inject,
} from '@vue/composition-api';
import {
  DictionaryForm,
  TextOccurrencesCountResponseItem,
  Word,
} from '@oare/types';
import sl from '@/serviceLocator';
import GrammarDisplay from './components/GrammarDisplay.vue';
import SpellingDisplay from './components/SpellingDisplay.vue';
import TextOccurrences from '@/components/TextOccurrences/index.vue';
import UtilList from '@/components/UtilList/index.vue';
import EventBus, { ACTIONS } from '@/EventBus';
import { ReloadKey } from '@/views/DictionaryWord/index.vue';

export default defineComponent({
  components: {
    GrammarDisplay,
    SpellingDisplay,
    UtilList,
    TextOccurrences,
  },
  props: {
    word: {
      type: Object as PropType<Word>,
      required: true,
    },
    form: {
      type: Object as PropType<DictionaryForm>,
      required: true,
    },
    updateForm: {
      type: Function as PropType<(newForm: DictionaryForm) => void>,
      required: true,
    },
    uuidToHighlight: {
      type: String,
      default: null,
    },
    allowEditing: {
      type: Boolean,
      default: true,
    },
    spellingOccurrencesCounts: {
      type: Array as PropType<TextOccurrencesCountResponseItem[]>,
      default: null,
    },
  },
  setup(props) {
    const store = sl.get('store');
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');
    const router = sl.get('router');
    const reload = inject(ReloadKey);

    const routeName = router.currentRoute.name;
    const spellingDialogOpen = ref(false);
    const editing = ref(false);
    const loading = ref(false);
    const isCommenting = ref(false);
    const editForm = ref({
      ...props.form,
    });

    const formTotalOccurrences = computed(() =>
      props.spellingOccurrencesCounts !== null
        ? props.spellingOccurrencesCounts.reduce(
            (sum, element) => sum + element.count,
            0
          )
        : null
    );

    const textOccurrenceDialog = ref(false);

    const canEdit = computed(() => store.hasPermission('UPDATE_FORM'));

    const canAddSpelling = computed(() => store.hasPermission('ADD_SPELLING'));

    const canComment = computed(() => store.hasPermission('ADD_COMMENTS'));

    const saveFormEdit = async (): Promise<void> => {
      loading.value = true;
      try {
        await server.updateForm(editForm.value.uuid, {
          newForm: editForm.value.form,
        });
        props.updateForm(editForm.value);
        actions.showSnackbar('Form successfully updated');
        editing.value = false;
      } catch (err) {
        actions.showErrorSnackbar('Error updating form', err as Error);
      } finally {
        loading.value = false;
      }
    };

    const openComment = (uuid: string, word: string) => {
      EventBus.$emit(ACTIONS.COMMENT_DIALOG, {
        uuid,
        word,
      });
    };

    const openEditDialog = (form: DictionaryForm) => {
      EventBus.$emit(ACTIONS.EDIT_WORD_DIALOG, {
        form,
        allowDiscourseMode: false,
      });
    };

    const spellingUuids = ref<string[]>([]);

    onMounted(() => {
      spellingUuids.value = props.form.spellings.map(({ uuid }) => uuid);
    });

    const getSpellingOccurrencesByUuid = (
      spellingUuid: string
    ): number | null => {
      if (props.spellingOccurrencesCounts === null) {
        return null;
      }
      const item = props.spellingOccurrencesCounts.find(
        item => item.uuid === spellingUuid
      );
      return item ? item.count : 0;
    };

    const disconnectSpellings = async (discourseUuids: string[]) => {
      try {
        await server.disconnectSpellings(discourseUuids);
      } catch (err) {
        actions.showErrorSnackbar(
          'Error disconnecting spellings. Please try again.',
          err as Error
        );
      }
    };

    return {
      isCommenting,
      editing,
      canEdit,
      canAddSpelling,
      canComment,
      editForm,
      loading,
      saveFormEdit,
      spellingDialogOpen,
      routeName,
      openComment,
      openEditDialog,
      textOccurrenceDialog,
      server,
      spellingUuids,
      getSpellingOccurrencesByUuid,
      formTotalOccurrences,
      reload,
      disconnectSpellings,
    };
  },
});
